import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  button: {
    description: 'Order overview button',
    defaultMessage: 'Order Overview',
    id: 'K105AD',
  },
});
